module.exports = __webpack_public_path__ + "static/media/photo.14afc164.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/photo.png
// module id = 1488
// module chunks = 47